import { useCallback } from "react";
import type { Information } from "@/shared/lib/api/api-client";
import { apiClient } from "@/shared/lib/api/api-client";

interface UseInformationDeleteOptions {
	onSuccess?: (message?: string) => void;
	onError?: (message: string) => void;
}

interface UseInformationDeleteReturn {
	deleteInformation: (
		info: Information,
		currentPageItemsCount: number,
		currentPage: number,
	) => Promise<{ shouldDecrementPage: boolean }>;
}

export const useInformationDelete = ({
	onSuccess,
	onError,
}: UseInformationDeleteOptions = {}): UseInformationDeleteReturn => {
	const deleteInformation = useCallback(
		async (info: Information, currentPageItemsCount: number, currentPage: number) => {
			try {
				const result = await apiClient.information.delete(info.id);

				if (result.error) {
					onError?.(`削除に失敗しました: ${result.error}`);
					return { shouldDecrementPage: false };
				}

				onSuccess?.("削除しました");

				// 現在のページの最後のアイテムを削除する場合、ページを1つ戻す
				const shouldDecrementPage = currentPageItemsCount === 1 && currentPage > 1;
				return { shouldDecrementPage };
			} catch (_error) {
				onError?.("削除に失敗しました");
				return { shouldDecrementPage: false };
			}
		},
		[onSuccess, onError],
	);

	return {
		deleteInformation,
	};
};
